module.exports = __webpack_public_path__ + "img/cirLight_0_1.dafc0d45.png";